<template>
    <div>
        <el-table
            ref="verified-caller-id-bundle-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
            <!-- Information Column -->
            <el-table-column
                prop="sid"
                label="Information"
                width="320"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="scope.row"
                        :show-verified-caller-id="true"
                        :show-verified-caller-id-details="true"
                        name-field="friendly_name"
                    />
                </template>
            </el-table-column>

            <!-- Timestamps Column -->
            <el-table-column
                label="Timestamps"
                width="140"
            >
                <template v-slot="scope">
                    <TimestampsColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Campaign & Incoming Number Column -->
            <el-table-column
                label="Line & Phone Number"
                prop="campaign_id"
                width="250"
            >
                <template v-slot="scope">
                    <LineColumn 
                        :row="scope.row"
                        :show-incoming-number="true"
                    />
                </template>
            </el-table-column>

            <!-- User Column -->
            <el-table-column
                label="Requested By"
                prop="user_id"
                width="150"
            >
                <template v-slot="scope">
                    <span v-if="scope.row.user && scope.row.user.name">{{ scope.row.user.name }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <!-- Validation Details Column -->
            <el-table-column
                label="Validation Details"
                width="200"
            >
                <template v-slot="scope">
                    <div v-if="scope.row.validation_code">
                        <p class="mb-0 font-weight-bold">Validation Code:</p>
                        <p class="mb-0">{{ scope.row.validation_code }}</p>
                    </div>
                    <div v-if="scope.row.caller">
                        <p class="mb-0 font-weight-bold">Called by:</p>
                        <p class="mb-0">{{ getCaller(scope.row.caller) }}</p>
                    </div>
                    <div v-if="scope.row.call_status">
                        <p class="mb-0 font-weight-bold">Call Status:</p>
                        <p class="mb-0">{{ getCallStatus(scope.row.call_status) }}</p>
                    </div>
                </template>
            </el-table-column>

            <!-- Status Column -->
            <el-table-column
                label="Status"
                prop="status"
                width="120"
            >
                <template v-slot="scope">
                    <StatusColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Failure Reason Column -->
            <el-table-column
                label="Failure Reason"
                prop="failure_reason"
            >
                <template v-slot="scope">
                    <FailureReasonColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column
                label="Action"
                width="150"
            >
                <template v-slot="scope">
                    <div class="mt-1">
                        <el-button
                            type="danger"
                            size="mini"
                            class="btn-block"
                            @click="handleDeleteBundle(scope.row)"
                            :loading="loadingDeleteBundle.includes(scope.row.id)"
                        >
                            Delete
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import InformationColumn from '../columns/information-column'
import TimestampsColumn from '../columns/timestamps-column'
import LineColumn from '../columns/line-column'
import FailureReasonColumn from '../columns/failure-reason-column'
import StatusColumn from '../columns/status-column'

export default {
    name: 'VerifiedCallerIdBundleTable',
    components: {
        InformationColumn,
        TimestampsColumn,
        LineColumn,
        FailureReasonColumn,
        StatusColumn,
    },
    props: {
        bundles: {
            type: Array,
            required: true,
        },
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        loadingUpdateBundle: {
            type: Array,
            default: () => [],
        },
        loadingDeleteBundle: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        handleDeleteBundle(bundle) {
            this.$emit('delete-bundle', bundle)
        },
        formatPhoneNumber(phoneNumber) {
            if (!phoneNumber) {
                return '-'
            }

            return this.$options.filters.fixPhone(phoneNumber, 'INTERNATIONAL')
        },
        getCaller(caller) {
            if (!caller) {
                return '-'
            }

            return this.$options.filters.fixPhone(caller, 'INTERNATIONAL')
        },
        getCallStatus(callStatus) {
            if (!callStatus) {
                return '-'
            }

            return this.$options.filters.ucfirst(callStatus)
        },
    },
}
</script>
